import { GoogleFontProperties } from 'common/utils/fontsUtils'
import { PageEntityInterface } from '../types/base-entity-interface'
import {
  GlobalFontProperties,
  GoogleFontsGenerator,
} from './google-fonts-generator'
import { removeDuplicates } from './remove-duplicates'

export class WebsiteGoogleFontsGenerator extends GoogleFontsGenerator {
  public generateFonts(
    entities: PageEntityInterface[],
    globalFontProperties: GlobalFontProperties,
    websiteStylesTypography: GoogleFontProperties[],
  ) {
    const entitiesFontCss = super.generate(entities, globalFontProperties)

    const websiteStylesFontProperties = removeDuplicates(
      websiteStylesTypography.filter(fv => this.isGoogleFontVariant(fv)),
      ['fontFamily', 'fontWeight', 'fontStyle'],
    )

    const websiteStylesFontCss = this.getFontFace(websiteStylesFontProperties)

    return `${entitiesFontCss}\n${websiteStylesFontCss}`
  }
}
